import _ from 'underscore'
import React from 'react'
import ReactDOM from 'react-dom'
import thunkMiddleware from 'redux-thunk'
import 'babel-polyfill'

import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import { clipArtManagementApp, initialState } from '../data/ClipArtManagementReducer'


import ClipArtManagementPage from '../components/ClipArtManagementPage'

import '../less/core.less'
import ExpiredTokenPage from "../components/ExpiredTokenPage";

// APP ENTRY POINT

// Build the Redux parts
const bootstrappedState = _.extend(initialState, window.bootstrappedState || {});
const createStoreWithMiddleware = applyMiddleware(thunkMiddleware)(createStore)
const store = createStoreWithMiddleware(clipArtManagementApp, bootstrappedState)

ReactDOM.render(
	<Provider store={store}>
		<ExpiredTokenPage />
	</Provider>, 
	document.getElementById('content')
)



// WEBPACK FOOTER //
// ./src/entry/ExpiredTokenApp.jsx